
<template>
  <b-modal
    title="Update Location"
    header-bg-variant="success"
    header-text-variant="light"
    size="lg"
    :visible="showModal"
    centered
    @hidden="reset"
    >

     <b-row v-show="updateLocationPending">
      <h2  class="u-padding-bottom-20">Updating, please wait ...</h2>
      <pulse-loader :loading="updateLocationPending" :color="spinnerColor" :size="spinnerSize"></pulse-loader>
    </b-row>

    <b-row v-if="!updateLocationPending">
      <b-col>
        <b-form>
        <div v-if="selectedLocationRec"><b>ID: </b>{{selectedLocationRec.id}}</div>

          <b-form-group label="Location Name" label-class='addpersonlabel' label-for="updatedTitle">
            <b-form-input data-vv-name="title" v-validate="'required'" data-vv-as="Title" id="title" size="md" type='text' name="title" v-model="updatedTitle"></b-form-input>
            <span v-show="inputValidationErrors.has('title')" class="text-info">{{ inputValidationErrors.first('title') }}</span>
          </b-form-group>

          <b-form-group
            label-cols-sm="3"
            label="Street:"
            label-align-sm="left"
            label-for="nested-street"
          >
            <b-form-input data-vv-name="addressStreet" v-validate="'required'" data-vv-as="Street" id="nested-street" v-model="updatedStreet"></b-form-input>
            <span v-show="inputValidationErrors.has('addressStreet')" class="text-info">{{ inputValidationErrors.first('addressStreet') }}</span>
          </b-form-group>

          <b-form-group
            label-cols-sm="3"
            label="City:"
            label-align-sm="left"
            label-for="nested-city"
          >
            <b-form-input data-vv-name="addressCity" v-validate="'required'" data-vv-as="City" id="nested-city" v-model="updatedCity"></b-form-input>
            <span v-show="inputValidationErrors.has('addressCity')" class="text-info">{{ inputValidationErrors.first('addressCity') }}</span>
          </b-form-group>

          <b-form-group
            label-cols-sm="3"
            label="County / Parish:"
            label-align-sm="left"
            label-for="nested-county"
          >
           <b-form-select
              id="nested-country"
              v-validate="'required'"
              data-vv-name="addressCounty"
              data-vv-as="County"
              :options="countyOrParishOptions()"
              v-model="updatedCounty">
            </b-form-select>
            <span v-show="inputValidationErrors.has('addressCounty')" class="text-info">{{ inputValidationErrors.first('addressCounty') }}</span>
            <b-form-checkbox
              style='margin-left: 20'
                id="cityHall"
                name="cityHall"
                v-model="isCityHall"
                @change="updateCityHall">
                City Hall
              </b-form-checkbox>
          </b-form-group>

          <b-form-group
            label-cols-sm="3"
            label="State:"
            label-align-sm="left"
            label-for="nested-state"
          >
            <b-form-select
              id="nested-state"
              :options="mailingStateOptions()"
              data-vv-name="addressState"
              v-validate="'required'"
              data-vv-as="State"
              v-model="updatedState">
            </b-form-select>
            <span v-show="inputValidationErrors.has('addressState')" class="text-info">{{ inputValidationErrors.first('addressState') }}</span>
          </b-form-group>

          <b-form-group
            label-cols-sm="3"
            label="Zip:"
            label-align-sm="left"
            label-for="nested-zip"
          >
            <b-form-input data-vv-name="addressZip" v-validate="'required'" data-vv-as="Zip" id="nested-zip" v-model="updatedZip"></b-form-input>
            <span v-show="inputValidationErrors.has('addressZip')" class="text-info">{{ inputValidationErrors.first('addressZip') }}</span>
          </b-form-group>

          <b-form-group
            label-cols-sm="3"
            label="Latitude:"
            label-align-sm="left"
            label-for="nested-lat"
          >
            <b-form-input data-vv-name="latitude" v-validate="'required|between:25.831064,49.400387'" data-vv-as="Latitude" id="nested-lat" v-model="updatedLatitude"></b-form-input>
            <span v-show="inputValidationErrors.has('latitude')" class="text-info">{{ inputValidationErrors.first('latitude') }}</span>
          </b-form-group>
          <b-form-group
            label-cols-sm="3"
            label="Longitude:"
            label-align-sm="left"
            label-for="nested-long"
          >
            <b-form-input data-vv-name="longitude" v-validate="'required|between:-66.947582,-124.735538'" data-vv-as="Longitude" id="nested-long" v-model="updatedLongitude"></b-form-input>
            <span v-show="inputValidationErrors.has('longitude')" class="text-info">{{ inputValidationErrors.first('longitude') }}</span>
          </b-form-group>


        </b-form>
      </b-col>
      <b-col>
        <br>
        <b>Created At: </b>  {{ $moment.unix(_.get(selectedLocationRec, 'createdAt', 1000) / 1000).format("MM/DD/YYYY") }}
        <div v-if="_.isObject(selectedLocationRec.createdBy)">
          <b> by: </b> {{ _.get(selectedLocationRec, 'createdBy.emailAddress', '') }}
        </div>
        <br>
        <b>Last Updated: </b>  {{ $moment.unix(_.get(selectedLocationRec, 'updatedAt', 1000) / 1000).format("MM/DD/YYYY") }}
        <div v-if="_.isObject(selectedLocationRec.updatedBy)">
          <b> by: </b> {{ _.get(selectedLocationRec, 'updatedBy.emailAddress', '') }}
        </div>
        <br>
        <br>
        <b-alert
            :show="!uniqueLocationName"
            variant="warning"
            >
            <span>Please enter a unique location name.</span>
          </b-alert>
      </b-col>
    </b-row>

    <b-alert
      fade
      :show="updateLocationFailure || _.isObject(updateLocationSuccess)"
      :variant="updateLocationFailure ? 'danger' : 'success'"
    >
      <span v-html="apiResponseMessage()"></span>
    </b-alert>

    <div slot="modal-footer" class="w-100">
      <b-button
        v-if="!disableDelete"
          type="button"
          variant="outline-primary"
          size="sm"
          class="float-left"
          @click="deleteHandler"
      >
        <span class="button-text">Delete</span>
      </b-button>
      <!--
        <span v-else class="text-danger"> This is the primary organization for this user.  It cannot be removed.  </span>
      -->
      <b-button
          type="button"
          variant="outline-primary"
          size="sm"
          class="float-right"
          @click="locationHandler"
      >
        <span class="button-text">Update</span>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
const texasData = require('../../store/data/cityHallTX.json')
const louisianaData = require('../../store/data/cityHallLA.json')

export default {
  name: 'update-location-modal',
  props: {
    organizationId: Number,
    selectedLocationRec: {
      type: Object,
      default () {
        return {}
      }
    },
    orgLocations: Array,
    showModal: Boolean,
    disableDelete: Boolean
  },
  computed: {
    ...mapGetters({
      user: 'getViewUser',
      updateLocationPending: 'getUpdateLocationPending',
      updateLocationFailure: 'getUpdateLocationFailure',
      updateLocationSuccess: 'getUpdateLocationSuccess',
      stateAndAbbrev: 'getStateAndAbbrev',
      countyOptions: 'getCountyData',
      parishOptions: 'getLAParishData'
    })
  },
  data: function () {
    return {
      uniqueLocationName: true,
      updatedTitle: '',
      updatedStreet: '',
      updatedCity: '',
      updatedCounty: '',
      updatedState: '',
      updatedZip: '',
      updatedLatitude: '',
      updatedLongitude: '',
      isCityHall: false,
      spinnerColor: '#489AAC',
      spinnerSize: '50px'
    }
  },
  watch: {
    updateLocationSuccess: function (newValue) {
      if (this.showModal) {
        _.delay(this.reset, 1000)
      }
    },
    showModal (newValue) {
      if (newValue) {
        this.showModal = newValue
      }
    },
    selectedLocationRec (newValue) {
      if (newValue) {
        this.populateUpdatedLocation(newValue)
      }
    },
    updatedCounty (newValue) {
      if (newValue && this.updatedState && this.isCityHall) {
        this.updateCityHall(this.isCityHall)
      }
    },
    updatedState (newValue) {
      if (newValue && this.updatedCounty && this.isCityHall) {
        this.updateCityHall(this.isCityHall)
      }
    }
  },
  methods: {
    populateUpdatedLocation (value) {
      this.updatedTitle = value.title || ''
      this.updatedStreet = value.addressStreet || ''
      this.updatedCity = value.addressCity || ''
      this.updatedCounty = value.addressCounty || ''
      this.updatedState = value.addressState || ''
      this.updatedZip = value.addressZip || ''
      this.updatedLatitude = value.latitude || ''
      this.updatedLongitude = value.longitude || ''
    },

    countyOrParishOptions () {
      switch (this.updatedState) {
        case 'Texas':
          return this.countyOptions
        case 'Louisiana':
          return this.parishOptions
        default:
          this.addressCounty = ' '
          return []
      }
    },
    updateCityHall (change) {
      const isTexas = this.updatedState === 'Texas'
      const isLouisiana = this.updatedState === 'Louisiana'
      if (!change || (!isTexas && !isLouisiana)) {
        return
      }

      const cityHall = isTexas
        ? texasData.filter((item) => (item.County + ' County') === this.updatedCounty)[0]
        : louisianaData.filter((item) => (item.Parish) === this.updatedCounty)[0]
      if (!cityHall) {
        return
      }

      const cityAttr = isTexas ? 'City Name (county seat)' : 'City Name (parish seat)'
      this.updatedCity = cityHall[cityAttr]
      this.updatedStreet = cityHall['Full City Hall Address']
      this.updatedZip = cityHall['Zip']
      this.updatedLatitude = cityHall['Lat Coordinates']
      this.updatedLongitude = cityHall['Long Coordinates']
    },
    checkIfRequired () {
      switch (this.updatedState) {
        case 'Texas':
        case 'Louisiana':
          return 'required'
        default:
          return ''
      }
    },
    reset: function () {
      this.$emit('update:showModal', false)
      this.clearForm()
    },
    updateStateAbbr () {
      this.updatedState = _.result(_.find(this.stateAndAbbrev, obj => {
        return obj.text === this.organization.mailingState
      }), 'value')
    },
    mailingStateOptions () {
      return _.sortBy(this.stateAndAbbrev, 'text').map((state) => {
        return {value: state.text, text: state.text}
      })
    },
    locationHandler () {
      this.uniqueLocationName = true
      const title = this.updatedTitle
      let titleLC = title.toLowerCase()
      let orgTitles = this.orgLocations.map((o) => o.title)

      const currentTitleIndex = orgTitles.indexOf(this.selectedLocationRec.title)
      orgTitles.splice(currentTitleIndex, 1)
      orgTitles.forEach((orgTitle) => {
        if (orgTitle.toLowerCase() === titleLC) {
          this.uniqueLocationName = false
        }
      })

      // Hack way - not sure why reactivity isn't working!!
      this.$forceUpdate()

      if (this.uniqueLocationName && this.selectedLocationRec) {
        this.$store.dispatch('updateLocation', {
          id: this.selectedLocationRec.id,
          data: {
            title: this.updatedTitle,
            addressStreet: this.updatedStreet,
            addressCity: this.updatedCity,
            addressCounty: this.updatedCounty,
            addressState: this.updatedState,
            addressZip: this.updatedZip,
            latitude: this.updatedLatitude,
            longitude: this.updatedLongitude
          }
        })
      }
    },
    deleteHandler () {
      if (this.selectedLocationRec) {
        this.$store.dispatch('deleteLocation', {
          id: this.selectedLocationRec.id
        })
      }
    },
    apiResponseMessage () {
      let message = ''
      if (this.updateLocationSuccess) {
        message = 'Success!'

        this.$store.dispatch('getOrganizationView', {
          id: this.organizationId
        })
      }
      if (this.updateLocationFailure) {
        message = this.$utils.errorToHtml(this.updateLocationFailure)
      }
      return '<p>' + message + '</p>'
    },
    clearForm () {
      this.$store.commit('RESET_UPDATE_LOCATION')
      this.populateUpdatedLocation(this.selectedLocationRec)
    }
  },
  beforeDestroy () {
    this.reset()
  },
  created () {
    this.uniqueLocationName = true
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Admin/UpdateLocationModal.vue